import { createAction, props } from '@ngrx/store'

export const SOURCE = '[Concerned View]'

export const resetState = createAction(
    `${SOURCE} ResetState`,
)

export const setAllConcerned = createAction(
    `${SOURCE} SetAllConcerned`, props<{ data: any }>()
)

export const setConcernedDetails = createAction(
    `${SOURCE} SetConcernedDetails`, props<{ data: any }>()
)